<template lang="pug">
  div.h-100
    app-header(title='REGISTER', :progressCurrent="slideIndex", :progressMax="slideCount", @backSignal="goBack")
    transition(name="down", mode="out-in")
      div.wizard-body.bg-alt.h-100(v-if='showWizard')
        .container.pt-4
          b-carousel.h-100(id="carouselWizard", ref='carouselWizard', :no-touch="true", :interval="0", v-model="slideIndex")
            b-carousel-slide
              template(v-slot:img="")
                .container
                  b-form(v-on:submit.prevent='onSubmit()')
                    b-button(type='submit', v-show="false", ref='submit0')
                  h1 CONNECT WITH A WORLD OF ART COLLECTORS
                  h4 SUBMIT YOUR WORK TO BE LISTED ON THE WALL COLLECTIVE
                  // p We are dedicated to providing exposure, support and opportunity to talented artists
                  p Wall Collective is a carefully curated platform with a vision of promoting premium fine art. Our team of industry experts carefully review all applications, and reserve the right to select pieces based on our own internal guidelines.
                  p.d-inline Already signed up?
                    b-link.m-0.text-theme.ml-2(:href="artist_base_url") LOGIN AS ARTIST
            b-carousel-slide
              template(v-slot:img="")
                .container
                  b-form(v-on:submit.prevent='onSubmit()')
                    b-form-group(label="FIRST NAME")
                      b-form-input(name='given-name', type='text', v-model='inputForm.firstname', required='',  autocomplete="given-name", @keyup="setDisplayName()")
                    b-form-group(label="LAST NAME")
                      b-form-input(name='family-name', type='text', v-model='inputForm.lastname', required='',  autocomplete="family-name", @keyup="setDisplayName()")
                    b-form-group(label="DISPLAY NAME")
                      b-form-input(name='display-name', type='text', v-model='inputForm.display_name', required='',  autocomplete="display-name")
                    b-form-group(label="EMAIL")
                      b-form-input(type='email', v-model='inputForm.email', required='',  autocomplete="email")
                    b-form-group(label="PHONE")
                      b-form-input(type='tel', v-model='inputForm.phone', required='', pattern="\\d{10}", title='10 Digits only. No +27 or spaces please :)',  autocomplete="tel")
                    b-form-group(label="BASE CITY")
                      b-form-input.form-control(type='text', required, v-model='inputForm.base')
                    b-button(type='submit', v-show="false", ref='submit1')
            b-carousel-slide
              template(v-slot:img="")
                b-form(v-on:submit.prevent='onSubmit()')
                  .container
                    p Please enter full URLs (with https://www)
                    b-form-group(label="INSTAGRAM")
                      b-form-input.form-control(type='url', v-model='inputForm.instagram_url',  placeholder='e.g. https://www.instagram.com/wall_collective/')
                    b-form-group(label="FACEBOOK")
                      b-form-input.form-control(type='url', v-model='inputForm.facebook_url',  placeholder='e.g. https://www.facebook.com/wall_collective/')
                    b-form-group(label="BEHANCE")
                      b-form-input.form-control(type='url', v-model='inputForm.behance_url',  placeholder='e.g. https://www.behance.net/wall_collective/')
                    b-form-group(:label="`AVERAGE PRICE: ${formatRands(inputForm.price_avg)} ${inputForm.price_avg == 100000 ? '+' : ''}`")
                      b-form-input.form-control(type='range', v-model='inputForm.price_avg', min="1000", max="100000", step="1000" placeholder='price')
                    b-form-group(label="BIO")
                      b-form-textarea(rows='3', maxlength="512", max-rows='6' v-model='inputForm.bio', required='', placeholder='This will appear on your artists profile (512 characters or less)')
                    b-form-group(label="PORTFOLIO (file or link)")
                    b-row
                      .col-6
                        label Upload a file
                        b-form-file(accept='.pdf', placeholder="PDF with maximum size of 10 MB", :state="Boolean(inputForm.portfolio)", v-model='inputForm.portfolio')
                      //.col-2
                        span OR
                      .col-6
                        label Add a link
                        b-form-input.form-control(type='url', maxlength="512", v-model='inputForm.portfolio_url',  placeholder='e.g. https://www.link.to/my_portfolio/')
                    b-form-group(label="OTHER INFO")
                      b-form-textarea(rows='3', maxlength="512", max-rows='6' v-model='inputForm.other_info', placeholder='Any other qualifications, exhibitions or links that you would like to share? (512 characters or less)')
                  b-button(type='submit', v-show="false", ref='submit2')
            b-carousel-slide
              template(v-slot:img="")
                b-form(v-on:submit.prevent='onSubmit()')
                  .container
                    b-form-group
                      label PASSWORD
                      b-form-input(type="password", name="password", v-model="inputForm.password", required="", pattern="(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}")
                    b-form-group
                      label CONFIRM PASSWORD
                      b-form-input(type="password", name="password2", v-model="passwordRepeat", required="", pattern="(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}")
                    p Password must be at least 8 characters, with a number and an uppercase letter.
                    b-form-group
                      b-form-checkbox(v-model='aggree', switch)
                        span(href="") I agree to the Wall Collective
                        b-link.text-muted.mx-2(:to="{name: 'legal'}") General Terms and Conditions,
                        b-link.text-muted.mx-2(:to="{name: 'legal'}") Privacy Policy
                        span and
                        b-link.text-muted.mx-2(:to="{name: 'legal'}") Artist Submission terms
                    b-button(type='submit', v-show="false", ref='submit3')
            b-carousel-slide
              template(v-slot:img="")
                .container.pt-5.text-center
                  b-spinner(type="grow")
                  p.pt-5 SUBMITTING APPLICATION
    b-button#btn-bar(type='submit', :disabled="slideIndex == slideCount", @click="$refs[`submit${slideIndex}`].click()")
      span(v-if="slideIndex >= (slideCount-1)") REGISTER
      span(v-else="") NEXT
</template>

<script>

// import Vue from 'vue';
import { mapActions } from 'vuex';
import standardMix from '@/mixins/standardMix';
import { userService } from '@/services';
import router from '@/router';

export default {
  name: 'formWizard',
  components: {
  },
  mixins: [standardMix],
  data() {
    return {
      showWizard: false,
      inApartment: false,
      aggree: false,
      passwordRepeat: '',
      slideIndex: 0,
      slideCount: 4,
      inputForm: {
        firstname: '',
        lastname: '',
        display_name: '',
        phone: '',
        email: '',
        base: '',
        instagram_url: '',
        facebook_url: '',
        behance_url: '',
        bio: '',
        other_info: '',
        price_avg: 1000,
        portfolio: null,
        portfolio_url: '',
        password: '',
      },
    };
  },
  computed: {
  },
  methods: {
    ...mapActions('order', ['addOrder']),
    setDisplayName() {
      this.inputForm.display_name = `${this.inputForm.firstname} ${this.inputForm.lastname}`;
    },
    async onSubmit() {
      this.$refs.carouselWizard.next();
      if (this.slideIndex === this.slideCount - 1) {
        if (!this.inputForm.password || this.inputForm.password !== this.passwordRepeat) {
          try {
            this.goBack();
            this.error('Passwords do not match');
          } catch (error) {
            this.error(error);
          }
        } else if (!this.aggree) {
          this.goBack();
          this.error('Please agree to our terms and conditions first');
        } else {
          try {
            this.busy();
            await userService.registerArtist(this.inputForm);
            this.success('Registration success');
            router.push('/register-artist-ok');
          } catch (error) {
            this.slideIndex = 0;
            this.error(error);
          }
        }
      }
    },
    goBack() {
      if (this.slideIndex > 0) {
        this.$refs.carouselWizard.prev();
      }
    },
  },
  created() {
    // Reset carousel
    this.slideIndex = 0;
    // Pre-populate values here
  },
  mounted() {
    // Create animation effect
    setTimeout(() => { this.showWizard = true; }, 100);
  },
};
</script>

<style lang="scss" scoped>
  .wizard-body {
    z-index: 1000;
    background-color: white;
    // border-radius: 15px 15px 0 0;
    overflow-y: scroll;
  }
  .carousel-indicators > li {
    background-color: blue !important;
  }
  .down-enter-active, .page-leave-active {
    transition: transform 0.5s;
  }
  .down-enter {
    transform: translateY(100%);
  }
  .logo {
    width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/ArtistRegister.vue